const columnValidationWarning = {
  heading: "Column Names Need Attention",
  intro: {
    important: "Important:",
    text: "Some columns couldn't be found exactly as specified. Processing with missing columns could result in",
    exposureWarning: "unintended exposure of personal data",
    suffix: "Please review and fix the column names below.",
  },
  columnNotFound: "Column not found:",
  didYouMean: "Did you mean one of these?",
  percentSimilar: "{{percent}}% similar",
  noSimilarFound: "No similar columns found. Available columns:",
  fixColumnNames: "Fix Column Names",
  proceedAnyway: "⚠️ Proceed Anyway (Risk: personal-data exposure)",
  proTip: {
    label: "💡 Pro tip:",
    text: "Column matching is case-insensitive and ignores extra whitespace. Try:",
  },
};

export default columnValidationWarning;
